import { RESPONSE_CODE, STORAGE_KEYS } from '@/constants/storage'
import { customerTrackMallServe } from '@/service/arms'
import useChannelStore from '@/store/channel'
import useUserStore from '@/store/user'
import { useSubCodeFruitStore } from '@/subCodeFruit/store'
import { Toast } from 'antd-mobile'
import axios from 'axios'

const silentApis = [
	'/userInfo/tempSave',
	'/loan/order/trialConfirm',
	'/sso/login/sendPhoneVerifyCode'
]

const http = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json'
  }
})

http.interceptors.request.use((config) => { /* 请求之前拦截器 */
	if (!config.headers.Authorization) {
		const tokenFromStorage = localStorage.getItem(STORAGE_KEYS.TOKEN)
		const tokenFromStore = useUserStore.getState().token
		const token = tokenFromStore || tokenFromStorage || ''
		if (token) {
			config.headers.Authorization = token
		}
	}
	if (!config.headers.channel_code) {
		const channelCodeFromStorage = localStorage.getItem(STORAGE_KEYS.CHANNEL_CODE)
		const channelCodeFromStore = useChannelStore.getState().channelCode
		const channelCode = channelCodeFromStore || channelCodeFromStorage || ''
		if (channelCode) {
			config.headers.channel_code = channelCode
		}
	}
	return config
})


http.interceptors.response.use((response) => { /* 请求之后拦截器 */
  const res = response.data;
  
	if (res.code === RESPONSE_CODE.SUCCESS) {
		return res.data
  }
  
  if (res.code === RESPONSE_CODE.TOKEN_OVERDUE && useSubCodeFruitStore.getState().loanCashType) {
    // 现金贷token过期，跳转登录
    useUserStore.getState().clearToken()
    localStorage.removeItem(STORAGE_KEYS.TOKEN)
    let status = useSubCodeFruitStore.getState().creditQuotaStatus === 0 ? 'beforeCredit' : 'afterCredit'
    window.location.href = `/codeFruit/login?tokenExpired=${status}`
    return Promise.reject(response);
  }

	customerTrackMallServe(response.config.url || '', {
		data: response.config.data,
		params: response.config.params,
	}, {
		...response.data,
	}, `BUSINESS_CODE_${res.code.toString()}`)

	if (!silentApis.includes(response.config.url || '')) {
		Toast.show(res.msg)
	}
	return Promise.reject(response);
}, (error) => {
	const _response = error?.response || error
	const { config } = _response

	customerTrackMallServe(config?.url || '', {
		data: config?.data || {},
		params: config?.params || {},
	  }, {
		...(typeof _response?.data === 'object' ? _response?.data : {}),
	  }, `HTTP_CODE_${_response?.status || 'ERROR'}`)

	//提示错误信息
	console.log('response error', error);
	if (!silentApis.includes(error?.response?.config?.url || '')) {
		Toast.show('网络繁忙，请刷新重试')
	}
	return Promise.reject(error.response);
})

export function request <T = unknown>(options = {}): Promise<T> {
	return http.request(options);
}

export default request

